// Announcement bar is a static 4-word offer line (owner request, Oct 23).
// Seasonal rotation intentionally disabled; this element stays inert and
// never throws when the old seasonal hooks are absent.
class GsgSeasonalAnnouncement extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('[data-seasonal-occasion]')) return;
  }
}

if (!customElements.get('gsg-seasonal-announcement')) {
  customElements.define('gsg-seasonal-announcement', GsgSeasonalAnnouncement);
}
